import React, { useState } from "react";
import { Copy, ExternalLink, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { BRAND } from "../config/brand";
import { Logo } from "./Logo";

// Sync copy (keeps user activation, works before the new tab steals focus)
const copySync = (text) => {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.cssText = "position:fixed;opacity:0;top:0;left:0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try { ok = document.execCommand("copy"); } catch (e) { ok = false; }
  document.body.removeChild(ta);
  return ok;
};

const copyCode = () => {
  const code = BRAND.partnerCode;
  if (copySync(code)) return toast.success("Código copiado!");
  if (!navigator.clipboard) return toast(`Copie o código manualmente: ${code}`);
  navigator.clipboard.writeText(code)
    .then(() => toast.success("Código copiado!"))
    .catch(() => toast(`Copie o código manualmente: ${code}`));
};

export const AreaWebButton = ({ testId = "area-web-btn", className = "", children }) => {
  const [open, setOpen] = useState(false);
  const copyAndOpen = () => {
    copyCode();
    window.open(BRAND.webAreaUrl, "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <button type="button" data-testid={testId} onClick={() => setOpen(true)} className={className}>{children}</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="area-web-modal" className="max-w-md bg-surface border-white/10 text-white">
          <DialogHeader>
            <Logo className="h-24 mx-auto mb-2" testId="area-web-logo" />
            <DialogTitle className="flex items-center gap-2 text-xl font-extrabold">
              <KeyRound className="w-5 h-5 text-brand-2" /> Área Web do Cliente
            </DialogTitle>
            <DialogDescription className="text-silver/80 leading-relaxed">
              Na tela do player, cole o código no campo <strong className="text-white">Código Parceiro</strong> e depois informe seu usuário e senha.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-2 rounded-2xl border border-brand-2/40 bg-ink/70 p-5 text-center">
            <p className="text-xs uppercase tracking-[0.25em] text-silver/70 font-bold">Seu código parceiro</p>
            <div className="mt-2 flex items-center justify-center gap-3">
              <span data-testid="partner-code-value" className="select-all text-4xl font-extrabold tracking-[0.15em] brand-gradient-text">{BRAND.partnerCode}</span>
              <button type="button" onClick={copyCode} data-testid="copy-partner-code-icon" aria-label="Copiar código" title="Copiar código" className="p-2 rounded-lg bg-white/5 hover:bg-white/15 border border-white/10 transition-colors">
                <Copy className="w-4 h-4 text-white" />
              </button>
            </div>
          </div>
          <button type="button" onClick={copyAndOpen} data-testid="copy-partner-code-btn" className="mt-2 w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-brand-gradient text-white font-bold shadow-xl shadow-brand/30 hover:brightness-110 transition">
            <ExternalLink className="w-5 h-5" /> Copiar código e abrir Área Web
          </button>
          <p className="text-center text-[11px] text-silver/50">Abre {BRAND.webAreaUrl.replace(/^https?:\/\//, "").replace(/\/$/, "")} em uma nova aba</p>
        </DialogContent>
      </Dialog>
    </>
  );
};
